import { useMemo } from "react";
import { useApi, apiResolver } from "@/api/useApi";
import {
  ConversationInTraining,
  TicketInTraining,
  CreateInteractionInTrainingRequest,
  ChangeStatusRequest,
  GetInteractionsInTrainingQueryDto,
  GetInteractionsInTrainingResponse,
  GetInteractionsByTopicResponse,
} from "./InteractionInTraining.model";

export function useInteractionInTrainingApi() {
  const { api } = useApi();

  return useMemo(
    () => ({
      getInteractionsByTopic: async (topicName: string) =>
        apiResolver<GetInteractionsByTopicResponse>(
          api.get(
            `/platform/interaction-in-training/topics/${encodeURIComponent(topicName)}`
          )
        ),

      getInteractionsInTraining: async (
        query?: GetInteractionsInTrainingQueryDto
      ) => {
        const params = new URLSearchParams();

        if (query?.topicIds) {
          query.topicIds.forEach((id) => {
            params.append("topicIds[]", id.toString());
          });
        }
        if (query?.interactionTypes) {
          query.interactionTypes.forEach((type) => {
            params.append("interactionTypes[]", type);
          });
        }
        if (query?.statuses) {
          query.statuses.forEach((status) => {
            params.append("statuses[]", status);
          });
        }
        if (query?.startDate) {
          params.append("startDate", query.startDate);
        }
        if (query?.endDate) {
          params.append("endDate", query.endDate);
        }
        if (query?.page) {
          params.append("page", query.page.toString());
        }

        const url = `/platform/interaction-in-training${params.toString() ? `?${params.toString()}` : ""}`;
        return apiResolver<GetInteractionsInTrainingResponse>(api.get(url));
      },

      createInteraction: async (request: CreateInteractionInTrainingRequest) =>
        apiResolver<ConversationInTraining | TicketInTraining>(
          api.post("/platform/interaction-in-training/create", request)
        ),

      changeStatus: async (request: ChangeStatusRequest) =>
        apiResolver<ConversationInTraining | TicketInTraining>(
          api.put("/platform/interaction-in-training/status", request)
        ),
    }),
    [api]
  );
}
